import axios from "axios";

const SERVICES_URL = process.env.REACT_APP_SERVICES_URL + "/api";

export const getUserInfoV2 = () => {
  const url = SERVICES_URL + "/login/user";
  return axios.get(url).then(response => response.data);
};
